export const salesTemplate = {
    name: "sales",
    callWindows: [
        {
            beginTime: {
                hour: 8,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "in",
                value: "AK,AZ,AR,CA,CO,DE,DC,GA,HI,ID,IL,IN,IA,KS,MO,MT,NE,NV,NH,NJ,NM,NY,NC,ND,OH,OR,PA,SC,SD,TN,VT,VA,WV,WI"
            },
            days: [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ],
            default: false,
            endTime: {
                hour: 21,
                minute: 0
            },
            order: 1
        },
        {
            beginTime: {
                hour: 8,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "eq",
                value: "AL"
            },
            days: [
                1,
                2,
                3,
                4,
                5,
                6
            ],
            default: false,
            endTime: {
                hour: 20,
                minute: 0
            },
            order: 2
        },
        {
            beginTime: {
                hour: 8,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "in",
                value: "FL,MD,MA,OK,WA,WY"
            },
            days: [
                1,
                2,
                3,
                4,
                5,
                6,
                0
            ],
            default: false,
            endTime: {
                hour: 20,
                minute: 0
            },
            order: 3
        },
        {
            beginTime: {
                hour: 9,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "eq",
                value: "CT"
            },
            days: [
                1,
                2,
                3,
                4,
                5,
                6,
                0
            ],
            default: false,
            endTime: {
                hour: 20,
                minute: 0
            },
            order: 4
        },
        {
            beginTime: {
                hour: 8,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "in",
                value: "LA,MS"
            },
            days: [
                1,
                2,
                3,
                4,
                5,
                6
            ],
            default: false,
            endTime: {
                hour: 20,
                minute: 0
            },
            order: 5
        },
        {
            beginTime: {
                hour: 10,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "eq",
                value: "KY"
            },
            days: [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ],
            default: false,
            endTime: {
                hour: 21,
                minute: 0
            },
            order: 6
        },
        {
            beginTime: {
                hour: 9,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "eq",
                value: "ME"
            },
            days: [
                1,
                2,
                3,
                4,
                5
            ],
            default: false,
            endTime: {
                hour: 21,
                minute: 0
            },
            order: 7
        },
        {
            beginTime: {
                hour: 9,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "in",
                value: "MI,MN"
            },
            days: [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ],
            default: false,
            endTime: {
                hour: 21,
                minute: 0
            },
            order: 8
        },
        {
            beginTime: {
                hour: 8,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "eq",
                value: "UT"
            },
            days: [
                1,
                2,
                3,
                4,
                5,
                6
            ],
            default: false,
            endTime: {
                hour: 21,
                minute: 0
            },
            order: 9
        },
        {
            beginTime: {
                hour: 9,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "eq",
                value: "TX"
            },
            days: [
                0,
                1,
                2,
                3,
                4,
                5
            ],
            default: false,
            endTime: {
                hour: 21,
                minute: 0
            },
            order: 10
        },
        {
            beginTime: {
                hour: 12,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "eq",
                value: "TX"
            },
            days: [
                0
            ],
            default: false,
            endTime: {
                hour: 21,
                minute: 0
            },
            order: 11
        },
        {
            beginTime: {
                hour: 9,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "eq",
                value: "RI"
            },
            days: [
                1,
                2,
                3,
                4,
                5
            ],
            default: false,
            endTime: {
                hour: 18,
                minute: 0
            },
            order: 12
        },
        {
            beginTime: {
                hour: 10,
                minute: 0
            },
            callWindowQuery: {
                field: "state",
                operator: "eq",
                value: "RI"
            },
            days: [
                6
            ],
            default: false,
            endTime: {
                hour: 17,
                minute: 0
            },
            order: 12
        }
    ]
}

    